import { render } from "./m-change-password.vue?vue&type=template&id=0cdecc7c&scoped=true"
import script from "./m-change-password.vue?vue&type=script&lang=js"
export * from "./m-change-password.vue?vue&type=script&lang=js"

import "./m-change-password.vue?vue&type=style&index=0&id=0cdecc7c&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdecc7c"]])

export default __exports__